import { FiTarget, FiZap, FiTrendingUp, FiShield, FiActivity, FiBarChart } from "react-icons/fi";
import { LuSettings, LuUsers, LuCircleCheck, LuSmartphone, LuShieldCheck, LuPercent, LuShield, LuClipboardList, LuPalette, LuCode, LuRocket } from "react-icons/lu";

// 1. Hero Block Configuration
export const PpcAppHeroData = {
  backgroundImage: "/images/serviceBanners/PPCAndPaidAdvertising.webp",
  whiteImage: "/images/serviceBanners/PPCAndPaidW.webp",
  subTitle: "PPC & Paid Advertising Services",
  title: (
    <>
      Maximize ROI with <br /> <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-600">Smarter Paid Advertising</span>
    </>
  ),
  description:
    "We deliver data driven PPC advertising strategies that improve targeting accuracy, reduce ad spend wastage, and maximize ROI through optimized campaigns designed for higher conversions and measurable business growth.",
  primaryButton: {
    title: "Get a Performance Audit",
    onClick: () => console.log("PPC Audit clicked"),
  },
  secondaryButton: {
    title: "View Case Studies",
    onClick: () => console.log("PPC Work clicked"),
  },
  featureData: [
    {
      icon: "/images/services/website/high_performance.webp",
      title: "Precision Targeting",
      desc: "Reach high-intent audiences with smarter ad targeting.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/responsive.webp",
      title: "Smart Bidding",
      desc: "Automated bid optimization for better campaign efficiency.",
      iconColor: "#22d3ee",
    },
    {
      icon: "/images/services/website/secure.webp",
      title: "Performance Tracking",
      desc: "Clear attribution insights to measure ad performance.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/clean_code.webp",
      title: "Scalable Growth",
      desc: "Scale campaigns while maintaining cost efficiency.",
      iconColor: "#34d399",
    },
  ],
  floatingIcons: [
    {
      image: "/images/services/website/python.svg", // Representing data/AI logic
      top: "16%",
      right: "8%",
      containerSize: 80,
      iconSize: 60,
      glowColor: "rgba(168,85,247,0.35)",
      iconGlow: "rgba(168,85,247,0.9)",
    },
  ],
};
// 2. Performance Stats Block
export const ppcStatsData = [
  {
    icon: LuSettings,
    value: "150+",
    label: "Apps Built",
    colorClass: "text-[#00d2ff]",
    bgClass: "bg-[#00d2ff]/10",
    borderClass: "border-[#00d2ff]/20",
    glowClass: "shadow-[0_0_20px_rgba(0,210,255,0.15)]",
  },
  {
    icon: LuUsers,
    value: "90+",
    label: "Happy Clients",
    colorClass: "text-[#a855f7]",
    bgClass: "bg-[#a855f7]/10",
    borderClass: "border-[#a855f7]/20",
    glowClass: "shadow-[0_0_20px_rgba(168,85,247,0.15)]",
  },
  {
    icon: LuSmartphone,
    value: "50M+",
    label: "Downloads",
    colorClass: "text-[#06b6d4]",
    bgClass: "bg-[#06b6d4]/10",
    borderClass: "border-[#06b6d4]/20",
    glowClass: "shadow-[0_0_20px_rgba(6,182,212,0.15)]",
  },
  {
    icon: LuShieldCheck,
    value: "99.9%",
    label: "Crash-Free Apps",
    colorClass: "text-[#3b82f6]",
    bgClass: "bg-[#3b82f6]/10",
    borderClass: "border-[#3b82f6]/20",
    glowClass: "shadow-[0_0_20px_rgba(59,130,246,0.15)]",
  },
  {
    icon: LuPercent,
    value: "40%",
    label: "Faster Development",
    colorClass: "text-[#d946ef]",
    bgClass: "bg-[#d946ef]/10",
    borderClass: "border-[#d946ef]/20",
    glowClass: "shadow-[0_0_20px_rgba(217,70,239,0.15)]",
  },
  {
    icon: LuShield,
    value: "100%",
    label: "Client Satisfaction",
    colorClass: "text-[#6366f1]",
    bgClass: "bg-[#6366f1]/10",
    borderClass: "border-[#6366f1]/20",
    glowClass: "shadow-[0_0_20px_rgba(99,102,241,0.15)]",
  },
];

// 3. Solutions & Process Block

export const ppcSolutionsAndProcessData = {
  buildSubtitle: "WHAT WE OPTIMIZE",
  buildTitle: "Paid Advertising Strategies for Full-Funnel Growth",
  buildCards: [
    {
      title: "Audience Targeting",
      desc: "Reach the right customers through intent-based audience strategies.",
      icon: FiTarget,
      colorClass: "text-[#00d2ff]",
      bgClass: "bg-[#00d2ff]/10",
      borderClass: "border-[#00d2ff]/20 hover:border-[#00d2ff]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(0,210,255,0.25)]",
    },
    {
      title: "Smart Bid Optimization",
      desc: "Real-time bid adjustments designed to improve conversions.",
      icon: FiZap,
      colorClass: "text-[#3b82f6]",
      bgClass: "bg-[#3b82f6]/10",
      borderClass: "border-[#3b82f6]/20 hover:border-[#3b82f6]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(59,130,246,0.25)]",
    },
    {
      title: "Ad Performance Testing",
      desc: "Continuous creative testing to identify top-performing ads.",
      icon: FiTrendingUp,
      colorClass: "text-[#a855f7]",
      bgClass: "bg-[#a855f7]/10",
      borderClass: "border-[#a855f7]/20 hover:border-[#a855f7]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(168,85,247,0.25)]",
    },
    {
      title: "Lead Quality Optimization",
      desc: "Filter low-quality traffic to improve campaign results.",
      icon: FiShield,
      colorClass: "text-[#06b6d4]",
      bgClass: "bg-[#06b6d4]/10",
      borderClass: "border-[#06b6d4]/20 hover:border-[#06b6d4]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(6,182,212,0.25)]",
    },
    {
      title: "Conversion Tracking Setup",
      desc: "Track clicks, leads, and sales for accurate campaign measurement.",
      icon: FiActivity,
      colorClass: "text-[#34d399]",
      bgClass: "bg-[#34d399]/10",
      borderClass: "border-[#34d399]/20 hover:border-[#34d399]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(52,211,153,0.25)]",
    },
    {
      title: "ROI Optimization Strategy",
      desc: "Improve return on ad spend through data-driven campaign decisions.",
      icon: FiBarChart,
      colorClass: "text-[#f59e0b]",
      bgClass: "bg-[#f59e0b]/10",
      borderClass: "border-[#f59e0b]/20 hover:border-[#f59e0b]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(245,158,11,0.25)]",
    },
  ],
  processSubtitle: "OUR PERFORMANCE PROCESS",
  processTitle: "Our PPC Campaign Growth Process",
  processSteps: [
    {
      step: "01",
      title: "Audit & Research",
      description: "Identify campaign gaps and high-intent audience opportunities.",
      icon: LuUsers,
    },
    {
      step: "02",
      title: "Campaign Setup",
      description: "Build scalable ad structures designed for better performance.",
      icon: LuClipboardList,
    },
    {
      step: "03",
      title: "Campaign Launch",
      description: "Deploy targeted ads across the right marketing channels.",
      icon: LuPalette,
    },
    {
      step: "04",
      title: "Performance Optimization",
      description: "Continuously improve bids, targeting, and ad performance.",
      icon: LuCode,
    },
    {
      step: "05",
      title: "Conversion Tracking Setup",
      description: "Track clicks, leads, and sales for accurate ad measurement.",
      icon: LuCircleCheck, // Using compile-safe icon for build stability
    },
    {
      step: "06",
      title: "ROI Optimization Strategy",
      description: "Maximize return on ad spend using data-driven optimization.",
      icon: LuRocket,
    },
  ],
  benefitsSubtitle: "WHY BUSINESSES CHOOSE OUR PPC STRATEGY",
  benefitsTitle: "Built for Performance & Smarter Ad Results",
  benefits: [
    "Intent-based audience targeting for better conversions",
    "Smart bid optimization to reduce wasted ad spend",
    "Clear performance tracking with measurable ROI insights",
    "Continuous ad testing to improve campaign results",
    "Lead quality filtering for higher-value conversions",
  ],
  logoImage: "/images/serviceBanners/PPCAndPaidAdvertising.webp",
  whiteLogoImage: "/images/serviceBanners/PPCAndPaidW.webp",
};

// 4. Portfolio / Results Block
export const ppcPortfolioData = {
  subtitle: "OUR RESULTS",
  title: "PPC Campaigns Built for Scale",
  buttonText: "View Case Studies",
  buttonLink: "#all-projects",
  apps: [
    {
      title: "Global FinTech",
      badge: "CPA Reduction",
      badgeColor: "bg-[#00d2ff]/10 text-[#00d2ff] border-[#00d2ff]/20",
      desc: "Reduced acquisition cost by 45% while doubling lead volume in 90 days.",
      downloads: "-45% CPA",
      rating: "5.0",
      image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=2070&auto=format&fit=crop",
    },
    {
      title: "D2C Brand",
      badge: "ROAS Scale",
      badgeColor: "bg-[#a855f7]/10 text-[#a855f7] border-[#a855f7]/20",
      desc: "Scaling monthly spend by 5x while maintaining a steady 4.2x ROAS across Meta and Google.",
      downloads: "5X Scale",
      rating: "4.9",
      image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?q=80&w=2070&auto=format&fit=crop",
    },
  ],
};

// 5. Technologies Data
export const ppcTechnologiesData = {
  techTitle: "OUR AD-TECH STACK",
  technologies: [
    { name: "Google Ads", icon: "Provider" },
    { name: "Meta Business", icon: "ReactNative" },
    { name: "Tracking APIs", icon: "RestAPI" },
    { name: "BigQuery/Data", icon: "SQLite" },
    { name: "Real-time Bidding", icon: "Vite" },
  ],
  trustTitle: "CERTIFIED PARTNERS",
  trustClients: [
    { image: "/images/logo/google_logo.png", alt: "google_logo" },
    { image: "/images/logo/microsoft_logo.png", alt: "microsoft_logo" },
    { image: "/images/logo/amazon_logo.png", alt: "amazon_logo" },
    { image: "/images/logo/Adobe_Corporate_logo.png", alt: "adobe_logo" },
    { image: "/images/logo/IBM_logo.png", alt: "ibm_logo" },
    { image: "/images/logo/Oracle_logo.png", alt: "oracle_logo" },
  ],
};

// 6. About Block
export const ppcAboutData = [
  {
    title: "PPC Advertising Services Designed for Measurable Growth",
    content: (
      <>
        Businesses often struggle with rising ad costs and campaigns that fail to generate meaningful results. Effective{" "}
        <b className="text-text-primary font-semibold">ppc advertising services</b> focus on improving efficiency by attracting the right audience while reducing wasted spending.
        Success in paid advertising comes from understanding customer intent, platform behavior, and campaign performance over time. At{" "}
        <b className="text-text-primary font-semibold">Tycho Technologies</b>, strategies are built around business goals, conversion patterns, and practical scaling methods to
        help brands achieve stronger digital growth with greater confidence.
      </>
    ),
  },
  {
    title: "Google Ads Management Company for Better Campaign Performance",
    content: (
      <>
        Managing paid campaigns requires more than launching ads and waiting for results. A reliable{" "}
        <b className="text-text-primary font-semibold">google ads management company</b> helps businesses improve visibility through structured campaign planning, keyword
        alignment, and budget efficiency. Brands investing in <b className="text-text-primary font-semibold">pay per click marketing services</b> often see stronger lead quality
        when campaigns are continuously refined based on performance insights. Tycho Technologies focuses on practical optimization strategies that support long-term growth while
        helping businesses improve return on advertising investment.
      </>
    ),
  },
  {
    title: "Paid Advertising Agency Focused on Qualified Leads",
    content: (
      <>
        Generating clicks alone does not create business growth. A trusted <b className="text-text-primary font-semibold">paid advertising agency</b> helps companies attract
        customers with stronger purchase intent and higher conversion potential. Businesses looking to improve audience quality often support paid acquisition with{" "}
        <a href="https://tychotechnologies.com/web3-community-building-services-india" className="text-cyan-400 underline hover:text-cyan-300">
          web3 community building
        </a>{" "}
        to strengthen engagement and build more meaningful digital relationships around products and services.
      </>
    ),
  },
  {
    title: "Why Businesses Choose a PPC Company in India",
    content: (
      <>
        The demand for a reliable <b className="text-text-primary font-semibold">ppc company in india</b> continues to grow as businesses seek scalable advertising strategies that
        deliver measurable outcomes. Brands working with a trusted <b className="text-text-primary font-semibold">google ads agency india</b> often prioritize transparency, budget
        control, and sustainable campaign improvements. Businesses partnering with Tycho Technologies gain access to customized advertising frameworks designed around performance
        and growth. Many organizations also improve retention by connecting paid campaigns with{" "}
        <a href="https://tychotechnologies.com/email-automation-services-india" className="text-cyan-400 underline hover:text-cyan-300">
          email marketing automation
        </a>{" "}
        to strengthen long-term customer engagement.
      </>
    ),
  },
];

// 7. FAQs
export const ppcFaqData = [
  {
    q: "Why should I use PPC management services in India for my business?",
    a: "PPC management services in India help businesses create and manage paid advertising campaigns on platforms like Google Ads and Bing Ads with expert optimization for maximum ROI.",
  },
  {
    q: "What are pay-per-click (PPC) services, and how can they benefit my business?",
    a: "PPC services involve managing online ads where you pay only for clicks. They help reach potential customers quickly, boost traffic, and generate high-quality leads within a set budget.",
  },
];
